import { Navigate, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requirePasswordSet = true }) {
  const { user, loading, mustChangePassword } = useAuth();
  const location = useLocation();
  const redirectState = useMemo(() => ({ from: location }), [location]);
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500" data-testid="auth-loading">Loading…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={redirectState} />;
  }
  if (requirePasswordSet && mustChangePassword) {
    return <Navigate to="/staff/set-password" replace />;
  }
  return children;
}
